import { RowAlertVehicleDto } from "@/dtos";
import { AlertVehicle } from "@/entities";
import { parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowAlertVehicleDto = (alertVehicles: AlertVehicle[]): RowAlertVehicleDto[] => {
    return alertVehicles.map(x => {
        const row: RowAlertVehicleDto = {
            ...x,
            vehicle: x.details?.vehicle,
            alert: x.details?.alert,
            sector: x.details?.sector,
            speedLimit: x.details?.speedLimit,
            dateTime: parseToLocalDateTimeFromUtc(x.date + " " + x.time),
            isNotificate: x.notificate ? 'Si' : 'No'
        }

        return row;
    });
}